import { createSlice } from '@reduxjs/toolkit';

import { getSmeStaffProductsThunk } from '../../services/staffProductService/staffProductThunk';

export type SmeStaffProduct = {
  id: string;
  code: string;
  interestRate: number;
  multiplier: number;
  minTenure: number;
  maxTenure: number;
  intervalTenure: number;
  minLoanAmount: number;
  maxLoanAmount: number;
  intervalLoanAmount: number;
  processingFee: number;
  stampingDutyPercentage: number;
  referralCode?: string | null;
  processingFeeToDiscount: number;
};

export type StaffProductState = {
  smeStaffProducts: {
    isLoading: boolean;
    isError: boolean;
    errorMessage: any;
    data: {
      total: number;
      currentPage: number;
      pageSize: number;
      data: SmeStaffProduct[];
    };
  };
};

const initialState: StaffProductState = {
  smeStaffProducts: {
    isLoading: false,
    isError: false,
    errorMessage: '',
    data: {
      total: 0,
      currentPage: 0,
      pageSize: 0,
      data: [],
    },
  },
};

export const staffProductSlice = createSlice({
  name: 'staffProduct',
  initialState,
  reducers: {
    staffStateReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSmeStaffProductsThunk.pending, (state) => {
        state.smeStaffProducts.isLoading = true;
      })
      .addCase(getSmeStaffProductsThunk.fulfilled, (state, action) => {
        state.smeStaffProducts.isLoading = false;
        state.smeStaffProducts.data = action.payload;
      })
      .addCase(getSmeStaffProductsThunk.rejected, (state, action) => {
        state.smeStaffProducts.isLoading = false;
        state.smeStaffProducts.isError = true;
        state.smeStaffProducts.errorMessage = action.payload;
      });
  },
});

export const { staffStateReset } = staffProductSlice.actions;

export default staffProductSlice.reducer;
